document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('ndb-locale__form')) return;
  const returnTo = form.elements.namedItem('return_to');
  if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ndb-locale__currency[open]').forEach(function (details) {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
function ndbKeepLanguage() {
  const root = window.Shopify?.routes?.root;
  if (!root || root === '/') return;
  const prefix = root.replace(/\/$/, '');
  document.querySelectorAll('.ndb a[href]').forEach(function (link) {
    const href = link.getAttribute('href');
    if (/^\/(pages|blogs|collections|policies|products)(\/|$)/.test(href)) link.setAttribute('href', prefix + href);
  });
}
ndbKeepLanguage();
document.addEventListener('shopify:section:load', ndbKeepLanguage);
